import React, { useState } from "react";

export default function CreateSalon() {
  const [formData, setFormData] = useState({
    salonName: "",
    ownerName: "",
    phoneNumber: "",
    address: "",
    description: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("FORM SUBMITTED", formData);

    setLoading(true);

  const savedTokens = JSON.parse(localStorage.getItem("zenvy_tokens"));
    try {
      const payload = {
        name: formData.salonName,
        owner_name: formData.ownerName,
        phone: formData.phoneNumber,
        address: formData.address,
        description: formData.description,
        category: "Barber",
        city: "Bangalore"
      };

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/salons`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${savedTokens?.access_token}`,
          },
          credentials: "include",
          body: JSON.stringify(payload),
        }
    );

      const data = await response.json();
      console.log("API RESPONSE:", data);

      if (response.ok) {
        alert("Salon created successfully!");
        window.location.href = "/owner";
      } else {
        alert(data.message || "Failed to create salon");
      }
    } catch (error) {
      console.error("CREATE SALON ERROR:", error);
      alert("Server error. Check console.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-6">
      <div className="bg-white shadow rounded-xl p-8 w-full max-w-lg">
        <h1 className="text-2xl font-bold mb-6 text-center">Create Your Salon</h1>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <input
            type="text"
            name="salonName"
            placeholder="Salon Name"
            value={formData.salonName}
            onChange={handleChange}
            className="w-full border rounded-lg p-3"
            required
          />

          <input
            type="text"
            name="ownerName"
            placeholder="Owner Name"
            value={formData.ownerName}
            onChange={handleChange}
            className="w-full border rounded-lg p-3"
            required
          />

          <input
            type="text"
            name="phoneNumber"
            placeholder="Phone Number"
            value={formData.phoneNumber}
            onChange={handleChange}
            className="w-full border rounded-lg p-3"
            required
          />

          <input
            type="text"
            name="address"
            placeholder="Salon Address"
            value={formData.address}
            onChange={handleChange}
            className="w-full border rounded-lg p-3"
            required
          />

          <textarea
            name="description"
            placeholder="Salon Description"
            value={formData.description}
            onChange={handleChange}
            className="w-full border rounded-lg p-3 min-h-[120px]"
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-black text-white rounded-lg p-3 font-semibold hover:opacity-90"
          >
            {loading ? "Creating..." : "Create Salon"}
          </button>
        </form>
      </div>
    </div>
  );
}